import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, categoryArticles } from '@/mocks/category';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

export default function Category() {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  const currentCategory = categories.find((c) => c.id === activeCategory)!;
  const articles = categoryArticles[activeCategory] || [];

  return (
    <PageSEO
      title="分类浏览 - 17c平台内容导航 | 17c官网"
      description="按分类浏览17c平台的全部内容，包括基础入门、功能详解、进阶技巧、实战案例、更新动态和常见问题，快速找到您需要的教程和指南。"
      keywords="17c分类,17c教程,17c功能,17c案例,17c常见问题"
      canonicalPath="/category"
    >
      <section className="pt-24 pb-16 md:pt-28 md:pb-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto fade-in-up">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '分类浏览' },
            ]}
          />

          <div className="text-center mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              分类浏览
            </h1>
            <p className="text-foreground-600 text-sm md:text-base">
              根据您的需求选择不同分类，快速找到相关内容
            </p>
          </div>

          <div className="flex flex-wrap gap-3 justify-center mb-12">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.id
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/60'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
                <span className={`text-xs ml-1 ${activeCategory === cat.id ? 'text-background-50/70' : 'text-foreground-400'}`}>
                  ({cat.count})
                </span>
              </button>
            ))}
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-foreground-950 mb-2">
              {currentCategory.name}
            </h2>
            <p className="text-sm text-foreground-600">
              {currentCategory.description}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className={`group block rounded-lg bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer fade-in-up`}
                style={{ animationDelay: `${0.1 + idx * 0.1}s` }}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex flex-wrap gap-2 mb-3">
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.date}</span>
                    <span>{article.readTime} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageSEO>
  );
}